"use client";

import React from "react";

const UnderstandingBruxism: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
      <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
        Understanding Bruxism: What It Is & Causes
      </h3>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        Bruxism is an involuntary habit characterized by the grinding, gnashing, or clenching of teeth. This condition can occur during the day (awake bruxism) or at night (sleep bruxism), with the latter being more common and often going unnoticed until symptoms arise.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        The exact causes of bruxism are not always clear, but several factors are believed to contribute to its development. Stress, anxiety, and tension are among the most common triggers for both daytime and nighttime teeth grinding. Other potential causes include:
      </p>
      <ul className="list-disc list-inside space-y-2 text-gray-700 text-base sm:text-lg">
        <li>Abnormal alignment of teeth or jaws (malocclusion)</li>
        <li>Sleep disorders, such as sleep apnea</li>
        <li>Certain medications or recreational drugs</li>
        <li>Caffeine and tobacco use</li>
        <li>Genetic predisposition</li>
      </ul>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        Identifying the underlying cause of your bruxism can help determine the most effective treatment approach. In some cases, addressing the root cause may be sufficient to stop the habit altogether.
      </p>
    </div>
  );
};

export default UnderstandingBruxism;